import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-feature-banner', {
  mixins: [eventListenerMixin],

  properties: {
    key: String,
  },

  ready() {
    this.listenTo(this.querySelector('.link-update-article'), 'click', this.clickArticleLink.bind(this));
    this.listenTo(this.querySelector('.link-to-dialog'), 'click', this.clickDialogLink.bind(this));
  },

  removeBanner() {
    this.remove();
  },

  confirmShown() {
    if (this.key) {
      $.post('/new_feature_confirmations', {
        metadata_key: `${this.key}_shown`,
      });
    }
  },

  clickDialogLink() {
    this.openDialog();
    this.confirmShown();
  },

  clickArticleLink(event) {
    this.confirmShown();
    this.removeBanner(event);
  },

  openDialog() {
    let videoGuide = this.querySelector('template').content.cloneNode(true);
    if (videoGuide) {
      document.body.appendChild(videoGuide);
      videoGuide = document.querySelector('tr-feature-video-guide');
      this.listenTo(videoGuide, 'tr-feature-video-guide:closed', () => {
        this.removeBanner();
      });
    }
  },

  disconnected() {
    this.stopListening();
  },
});
